import { Dialog, DialogProps } from "@/components/ui/Dialog"
import { ProgressBar } from "../ui/ProgressBar"
import { useTranslation } from "react-i18next"
import { useAtomValue } from "jotai"
import { stylePublishProgressAtom } from "@/store/style/publish-style"
import { StyleDraft } from "@/store/style/style-state"

export const StylePublishLoadingDialog = (
	props: Partial<DialogProps> & {
		title: string
		total: number
		description?: string
		styleDraft?: StyleDraft
	},
) => {
	const { total } = props
	const { t } = useTranslation("components")
	const progress = useAtomValue(stylePublishProgressAtom)

	return (
		<Dialog
			trackingViewName="style_publish_loading_dialog"
			contentSize="auto"
			{...props}
			canGoBack={false}
			disableClose={true}
		>
			<div className="flex flex-col space-y-4">
				<div className="text-md font-bold">{props.title}</div>
				<div className="flex flex-col space-y-4">
					<div className="text-sm text-base-400">
						{props.description ?? t("stylePublishLoadingDialog.defaultDescription")}
					</div>
					<div className="h-fit w-full">
						<ProgressBar max={total} value={progress} />
					</div>
				</div>
			</div>
		</Dialog>
	)
}
